import React from "react";
import "./RepayInfoPopup.css";

const RepayInfoPopup = ({ onClose, show = true }) => {
  if (!show) return null;

  return (
    <div className="repay-popup-overlay" onClick={onClose}>
      <div className="repay-popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="repay-popup-header">
          <div className="repay-popup-title-wrapper">
            <span className="repay-popup-alert-icon">⚠️</span>
            <h3>Security Alert / सुरक्षा चेतावनी</h3>
          </div>
          {/* <button className="repay-popup-close" onClick={onClose}>
            ×
          </button> */}
        </div>
        
        <div className="repay-popup-body">
          {/* Warning Section */}
          <div className="repay-popup-warning-section">
            <div className="repay-popup-warning-text">
              <p className="repay-popup-main-warning">
                <strong>English:</strong> Fraudsters are sending fake payment requests via WhatsApp, SMS, and social media, impersonating <span className="highlight-orange">snappaisa.com</span> employees. Stay alert:
              </p>
              <p className="repay-popup-main-warning">
                <strong>हिंदी:</strong> धोखेबाज़ WhatsApp, SMS और सोशल मीडिया के माध्यम से नकली भुगतान अनुरोध भेज रहे हैं, जो <span className="highlight-orange">snappaisa.com</span> के कर्मचारियों के रूप में पहचान बना रहे हैं। सतर्क रहें:
              </p>
            </div>
          </div>

          {/* Checklist Section */}
          <div className="repay-popup-checklist">
            <div className="repay-popup-checklist-item">
              <span className="check-icon">✓</span>
              <div className="checklist-content">
                <p><strong>English:</strong> Do not click unknown links or reply to suspicious messages.</p>
                <p><strong>हिंदी:</strong> अज्ञात लिंक पर क्लिक न करें या संदिग्ध संदेशों का जवाब न दें।</p>
              </div>
            </div>
            
            <div className="repay-popup-checklist-item">
              <span className="check-icon">✓</span>
              <div className="checklist-content">
                <p><strong>English:</strong> Verify email IDs and domains before engaging.</p>
                <p><strong>हिंदी:</strong> संलग्न होने से पहले ईमेल ID और डोमेन सत्यापित करें।</p>
              </div>
            </div>
            
            <div className="repay-popup-checklist-item">
              <span className="check-icon">✓</span>
              <div className="checklist-content">
                <p><strong>English:</strong> Be cautious of calls or messages claiming to be from us.</p>
                <p><strong>हिंदी:</strong> हमारे होने का दावा करने वाले कॉल या संदेशों से सावधान रहें।</p>
              </div>
            </div>
          </div>

          {/* Yellow Warning Box */}
          <div className="repay-popup-yellow-warning">
            <span className="warning-icon">⚠️</span>
            <div className="yellow-warning-content">
              <p><strong>English:</strong> <span className="highlight-orange">snappaisa.com</span> is not responsible for losses from payments to unverified persons or links.</p>
              <p><strong>हिंदी:</strong> <span className="highlight-orange">snappaisa.com</span> अप्रमाणित व्यक्तियों या लिंक को भुगतान से होने वाले नुकसान के लिए जिम्मेदार नहीं है।</p>
            </div>
          </div>

          {/* Safe Payment Section */}
          <div className="repay-popup-safe-payment">
            <div className="safe-payment-header">
              <span className="lock-icon">🔒</span>
              <h4>Safe Payment / सुरक्षित भुगतान</h4>
            </div>
            <div className="safe-payment-content">
              <div className="safe-payment-item">
                <p><strong>हिंदी:</strong> भुगतान केवल हमारी आधिकारिक वेबसाइट <span className="highlight-orange">snappaisa.com</span> या अधिकृत लिंक से करें।</p>
                <p><strong>English:</strong> Pay only through our official website <span className="highlight-orange">snappaisa.com</span> or authorized link.</p>
              </div>
              <div className="safe-payment-item">
                <p><strong>हिंदी:</strong> किसी अज्ञात नंबर/लिंक पर भरोसा न करें।</p>
                <p><strong>English:</strong> Do not trust any unknown number/link.</p>
              </div>
            </div>
          </div>

          {/* Signature */}
          <div className="repay-popup-signature">
            <p>- Team SnapPaisa</p>
          </div>
        </div>

        <div className="repay-popup-footer">
          <button className="repay-popup-ok-btn" onClick={onClose}>
            I UNDERSTAND / मैं समझ गया
          </button>
        </div>
      </div>
    </div>
  );
};

export default RepayInfoPopup;
